export function log(msg) {
	console.log('[DEBUG] ' + msg);
}

export function logE(msg) {
	console.log('[ERROR] ' + msg);
}
